/** A–F audience helpers for Online Lesson student labels + slide targeting. */

export const ONLINE_LESSON_LABELS = ['A', 'B', 'C', 'D', 'E', 'F'];
export const ONLINE_LESSON_AUDIENCES = ['all', 'A', 'B', 'C', 'D', 'E', 'F'];

export function normalizeLabel(value) {
    const raw = String(value || '').trim().toUpperCase();
    return ONLINE_LESSON_LABELS.includes(raw) ? raw : null;
}

export function normalizeAudience(value) {
    if (value == null || value === '') return 'all';
    const raw = String(value).trim().toLowerCase();
    if (raw === 'all') return 'all';
    const label = normalizeLabel(value);
    return label || 'all';
}

/** Cycle A → B → … → F → none (null). */
export function cycleLabel(current) {
    const cur = normalizeLabel(current);
    if (!cur) return 'A';
    const idx = ONLINE_LESSON_LABELS.indexOf(cur);
    if (idx < 0 || idx >= ONLINE_LESSON_LABELS.length - 1) return null;
    return ONLINE_LESSON_LABELS[idx + 1];
}

export function getStudentLabel(labelsMap, studentId) {
    if (!studentId) return null;
    return normalizeLabel((labelsMap || {})[studentId]);
}

/**
 * Whether a slide is visible to a student with the given label.
 * Teachers always see everything (callers should skip this check).
 * Unlabeled students only see audience "all".
 */
export function slideVisibleToStudent(slide, studentLabel) {
    const audience = normalizeAudience(slide?.audience);
    if (audience === 'all') return true;
    const label = normalizeLabel(studentLabel);
    return Boolean(label && label === audience);
}

export function audienceBadge(slide) {
    const audience = normalizeAudience(slide?.audience);
    return audience === 'all' ? null : audience;
}

export function withStudentLabel(labelsMap, studentId, nextLabel) {
    const next = { ...(labelsMap || {}) };
    const id = String(studentId || '');
    if (!id) return next;
    const label = normalizeLabel(nextLabel);
    if (!label) delete next[id];
    else next[id] = label;
    return next;
}
